import React from 'react';
import { useIntl } from 'react-intl';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _toString from 'lodash/toString';
import PropTypes from 'prop-types';
// Permissions
import OnlyWith from 'components/permissions/OnlyWith';
// Models
import mDoor from 'models/door';
import mEquipment from 'models/equipment';
// Custom
import { cpmDoorDataShape, permissionsShape } from 'constants/PropTypesShapes';
import InformationItem from 'components/items/InformationItem';

const doorEquipment = (dEquipment) => {
  const { equipment, usage } = dEquipment;
  // Type
  const { icon } = mEquipment.type(equipment);

  return {
    key: _toString(equipment.id),
    icon,
    label: <LocalizedMessage id={`door.equipment.usage.${usage}`} />,
    value: equipment.name,
  };
};

const CarparkDoorItem = ({
  door, withEquipments, toggle, action, rightIcon, permissions, withShadow, light, lightMode,
}) => {
  const intl = useIntl();

  // Usage
  const { icon } = mDoor.usage(door);

  return (
    <InformationItem
      label={intl.formatMessage({ id: `door.type.${door.type}` })}
      value={door.name}
      icon={icon}
      withAvatar={!light}
      withShadow={withShadow}
      light={light}
      lightMode={lightMode}
      toggle={toggle}
      rightButton={action ? <OnlyWith permissions={permissions}>{action}</OnlyWith> : null}
      rightIcon={rightIcon}
      nestedItems={withEquipments ? _map(door.equipments, doorEquipment) : null}
    />
  );
};

CarparkDoorItem.propTypes = {
  door: cpmDoorDataShape.isRequired,
  withEquipments: PropTypes.bool,
  toggle: PropTypes.shape({
    toggled: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
  }),
  action: PropTypes.node,
  rightIcon: PropTypes.element,
  permissions: permissionsShape,
  withShadow: PropTypes.bool,
  light: PropTypes.bool,
  lightMode: PropTypes.bool,
};

CarparkDoorItem.defaultProps = {
  withEquipments: false,
  toggle: null,
  action: null,
  rightIcon: null,
  permissions: null,
  withShadow: true,
  light: false,
  lightMode: true,
};

module.exports = CarparkDoorItem;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/main/CarparkDoorItem.js